<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-07 16:31:55
-->
<template>
  <div class="orderTimeCell">
      <div>
            <div>付款：{{ row['pay_success_time'] }}</div>
            <div>结算：{{ row['settle_time'] ? row['settle_time'] : '-' }}</div>
      </div>
      <div class="hint" v-if="row.attribution_status == 2">
        <i class="el-icon-warning mt-2"></i>
        <div class="fz-12 ml-4">该订单员工提成已超过到手服务费，请修改订单归属</div>
      </div>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin]
}
</script>
<style lang="less" scoped>
.hint {
  color: #FA8F14;
  display: flex;
  line-height: 18px;
  margin-top: 8px;
}
</style>